import React, { useEffect, useMemo, useState } from 'react';
import AdminHeading from '../AdminPanel/Heading/AdminHeading';
import AdminBreadCrump from '../AdminPanel/Heading/AdminBreadCrump';
import '../PagesStyles/AdminMasters.css';
import { Box } from '@mui/material';
import { TbCircleNumber1 } from 'react-icons/tb';
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a128,
  a129,
  a130,
  a18,
  a35,
  a7,
  a768,
  a769,
  a770,
  a771,
  a772,
  a95,
  a96,
  a97,
  a98,
  a99,
} from '../../Api/RootApiPath';
import { useSelector } from 'react-redux';
import { RiListUnordered, RiPlayListAddLine } from 'react-icons/ri';
import AlertMessage from '../../Other Functions/AlertMessage';
import { Icon } from '@iconify/react';
import { useRef } from 'react';
import style from './AddProductNew.module.css';
import Customertable from 'Components/support/customervendor/customer';
import toast from 'react-hot-toast';
import { useQuery } from '@tanstack/react-query';
import { getAllDiamondAttribute } from 'services/diamond';
import { looseDiamondId } from 'utils/helpers';
import exportToExcel from 'Components/CommonComponents/ExcelDownload';

export default function AddProductNew() {


  const [active, setActive] = useState('AddNew');
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [messageToShow, setMessageToShow] = useState('');
  const [loading, setLoading] = useState(false);

  const [searchInput, setSearchInput] = useState('');

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    CategoryId: '',
    ProductName: '',
    ShortName: '',
    Description: '',
    Slug: '',
    Status: '',
    Shape:"",
    ShapeName:"",
    Clarity:"",
    ClarityName:"",
    Color:"",
    ColorName:"",
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCategoriesList, setAllCategoriesList] = useState([]);
  const [visibleLooseDiamondField, setVisibleLooseDiamondField] = useState(false);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;

  const { data: diamondAttribute } = useQuery({
    queryKey: ["/addProduct/diamondAttribute", clientCode],
    queryFn: getAllDiamondAttribute,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });

  console.log(diamondAttribute)
  const attributeOption = useMemo(()=>{
    const clarityList = []
    const shapeList = []
    const colorList = []
    
    if(diamondAttribute?.length){
         diamondAttribute?.forEach((item)=>{
          if(item?.DiamondAttribute == "DiamondShape"){
            shapeList?.push(item)
          }
          if(item?.DiamondAttribute == "DiamondColour"){
            colorList?.push(item)
          }
          if(item?.DiamondAttribute == "DiamondClarity"){
            clarityList?.push(item)
          }
         })

    }
    return {
      colorList,
      shapeList,
      clarityList
    }
  },[diamondAttribute])

  console.log(attributeOption)

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);

  useEffect(()=>{
    console.log(newCategory?.CategoryId)
    if(newCategory?.CategoryId == looseDiamondId){
      setVisibleLooseDiamondField(true)
    }else{
      setVisibleLooseDiamondField(false)
    }
  },[newCategory?.CategoryId])

  const handleReset = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === 'SELECT') {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ''; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const columns = [
    { key: 'serialNumber', label: 'S.No', type: 'read', priority: 2 },
    { key: 'CategoryName', label: 'Category Name', type: 'read', priority: 1 },

    { key: 'ProductName', label: 'Product Name', type: 'read', priority: 3 },
    { key: 'ShortName', label: 'Short Name', type: 'read', priority: 4 },
    {
      key: 'Description',
      label: 'Description',
      type: 'read',
      priority: 5,
    },
    { key: 'Slug', label: 'Slug', type: 'read', priority: 6 },
  ];
  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log('Searching for:', searchTerm);
  };

  const handlenew = () => {
    setActive('AddNew');
  };
  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);
  // Handler function to move focus on Enter key press

  const submitButtonRef = useRef(null); // Ref for the Submit button

  const Submit = () => {
    console.log('submit is clicked');
  };

  const handleCLick = () => {
    setActive('List');

    console.log('Handle List clicked');
  };

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);

  const fetchAllCategoriesList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a125, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCategoriesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategoriesList();
  }, []);

  // Handler function to move focus on Enter key press
  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error('Submit button ref is not available');
        }
      }
    }
  };

  useEffect(() => {
    console.log('allCategories', allCategories);
    console.log('allCategoriesList', allCategoriesList);
  }, [allBranchesList, allCategories]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a772, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive('addNew');
        document
          .getElementById('addCategoryListTitle')
          .classList.add('activeCategoryTitle');
        document
          .getElementById('addCategoryListLogo')
          .classList.add('activeCategoryLogo');
        document.getElementById('addCategoryListTitle').click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);

  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);

  // const fetchAllCategories = async () => {
  //   try {
  //     const response = await fetch(a18);
  //     const data = await response.json();
  //     setAllCategories(data.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   fetchAllCategories();
  // }, []);

  console.log(allCategories, 'allCategories');
  console.log(allCompaniesList, 'allCompaniesList');
  console.log(allDepartmentsList, 'allDepartmentsList');
  console.log(allBranchesList, 'allBranchesList');
  console.log(allRolesList, 'allRolesList');
  console.log(allCategoriesList, 'allCategoriesList');

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
   
    if(name == "Shape"){
    const found = attributeOption?.shapeList?.find((item)=>item?.Id == value)
    setNewCategory({ ...newCategory, [name]: value,ShapeName:found?.DiamondValue });
    }else if(name == "Color"){
      const found = attributeOption?.colorList?.find((item)=>item?.Id == value)
      setNewCategory({ ...newCategory, [name]: value,ColorName:found?.DiamondValue });
    }else if(name == "Clarity"){
      const found = attributeOption?.clarityList?.find((item)=>item?.Id == value)
      setNewCategory({ ...newCategory, [name]: value,ClarityName:found?.DiamondValue });
    }else{
      setNewCategory({ ...newCategory, [name]: value })
    }
  };
  console.log(newCategory, 'newCategory');
  console.log(newCategory, 'newCategory');

  const [newProduct, setNewProduct] = useState({
    category: '',
    productTitle: '',
    slug: '',
    label: '',
    hsnCode: '',
    description: '',
  });

  const handleNewProductChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewProduct({ ...newProduct, [name]: value });
  };

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      CategoryId: newCategory.CategoryId,
      ProductName: newCategory.ProductName,
      ShortName: newCategory.ShortName,
      Description: newCategory.Description,
      Slug: newCategory.Slug,
      Status: 'Active',
      EmployeeCode: employeeCode,
      Shape:newCategory?.Shape,
      ShapeName:newCategory?.ShapeName,
      Clarity:newCategory?.Clarity,
      ClarityName:newCategory?.ClarityName,
      Color:newCategory?.Color,
      ColorName:newCategory?.ColorName,
      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a771 : a129,
        // a96,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive('List');
      setNewCategory({
        CategoryId: '',
        ProductName: '',
        ShortName: '',
        Description: '',
        Slug: '',
        Status: '',
        OldEntry: false,
        Color:"",
        ColorName:"",
        ClarityName:"",
        ShapeName:""
      });
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message, {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
        setActive('AddNew');
      } else {
        // setMessageType("success");
        toast.success('Product Added Successfully', {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleEditData = (data) => {
    console.log(data, 'data');
    console.log(data, 'data');
    console.log(data, 'data');
    setNewCategory({ ...data, OldEntry: true });
    setActive('AddNew');
  };

  const addNewProduct = async (e) => {
    setLoading(true);
    e.preventDefault();
    const formData = {
      Category_id: newProduct.category,
      ProductTitle: newProduct.productTitle,
      Label: newProduct.label,
      Slug: newProduct.slug,
      HSNCode: newProduct.hsnCode,
      Description: newProduct.description,
    };
    try {
      const response = await fetch(a21, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      fetchAllProducts();
      setActive('List');
      setNewProduct({
        category: '',
        productTitle: '',
        slug: '',
        label: '',
        hsnCode: '',
        description: '',
      });
      if (data.Message) {
        // alert(data.Message);
        setMessageType('error');
        setMessageToShow(data.Message);
        setShowError(true);
        setActive('AddNew');
      } else {
        setMessageType('success');
        setMessageToShow('Product Added Successfully');
        setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };


    const DownloadExcel = (data)=>{
      const headers = {
        'S.No': null, // Auto-generated
        'Category Name': 'CategoryName',
        'Product Name': 'ProductName',
        'Short Name': 'ShortName',
        'Description': 'Description',
        'Slug': 'Slug',
       
      };
      exportToExcel(data, headers, 'ProductData.xlsx');
    }
  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={'Add Product'}
          companyName={'Loyalstring'}
          module={'Product Masters'}
          page={'Product'}
        />

        <div style={{ padding: '16px' }}>
          {active == 'List' ? (
            <>
              <div className={style['white-space']}>
                <div className={style['icon-div']}>
                  <div className={style['search-container']}>
                    <input
                      type="text"
                      value={searchInput}
                      onChange={handleSearchChange}
                      placeholder="Search..."
                      className={style['serach-input']}
                    />
                    <button
                      style={{ margin: 0 }}
                      className={style['search-btn']}
                      //  onClick={handleSearchSubmit}
                    >
                      <Icon style={{ fontSize: '20px' }} icon="mdi:magnify" />
                    </button>
                  </div>

                  <Icon
                    onClick={()=>DownloadExcel(allCategories)}

                    style={{
                      fontSize: '28px ',
                      color: '#0077d4',
                      cursor: 'pointer',
                    }}
                    icon="bx:export"
                  />

                  <button
                    // style={{ width: "30%" }}
                    className={style['custom-btn']}
                  >
                    <Icon
                      style={{ fontSize: '24px ' }}
                      icon="ic:outline-print"
                    />
                    Print
                  </button>
                  <button
                    onClick={handlenew}
                    style={{ margin: 0 }}
                    className={style['custom-btn']}
                  >
                    New
                    <Icon icon="mdi:plus" width="24" height="24" />
                  </button>
                </div>
              </div>

              <Customertable
                columns={columns}
                allCategories={allCategories}
                handleEditData={handleEditData}
                searchInput={searchInput}
                setSearchInput={setSearchInput}

                // title={"All Customers"}
              />
            </>
          ) : (
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <form onSubmit={addNewCategory}>
                    <div
                      style={{
                        gridTemplateColumns: 'repeat(4,2fr)',
                        columnGap: '30px',
                        margin: '0px 0px',
                        padding: 'var(--Space-0, 0px) 24px',
                      }}
                    >
                      <Box sx={{ width: '95%', margin: '0 auto' }}>
                        <div
                          style={{
                            gridTemplateColumns: 'repeat(4,1fr)',
                            columnGap: '40px',
                            margin: '15px 0px',
                          }}
                          className="adminCategoryAddCategoryInnerBox"
                        >
                          <label>
                            Category <sup>*</sup>
                          </label>
                          <select
                            name="CategoryId"
                            value={newCategory.CategoryId}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            ref={inputRef1}
                            onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          >
                            <option value={''}>Select an option</option>;
                            {allCategoriesList.map((x) => {
                              return (
                                <>
                                  <option value={x.Id}>{x.CategoryName}</option>
                                  ;
                                </>
                              );
                            })}
                          </select>{' '}
                          <label>
                            Product Name<sup>*</sup>
                          </label>
                          <input
                            name="ProductName"
                            value={newCategory.ProductName}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style['addCategory-input']}
                            ref={inputRef2}
                            onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                          />

                          {visibleLooseDiamondField && (

                         <>
                          <label>
                            Shape <sup>*</sup>
                          </label>
                          <select
                            name="Shape"
                            value={newCategory.Shape}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            ref={inputRef3}
                            onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          >
                            <option value={''}>Select an option</option>;
                            {attributeOption?.shapeList?.map((x) => {
                              return (
                                <>
                                  <option value={x.Id}>{x.DiamondValue}</option>
                                  ;
                                </>
                              );
                            })}
                          </select>
                          </>
                            )}

                           {visibleLooseDiamondField && (
                            <>
                          <label>
                            Clarity <sup>*</sup>
                          </label>
                          <select
                            name="Clarity"
                            value={newCategory.Clarity}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            ref={inputRef4}
                            onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          >
                            <option value={''}>Select an option</option>;
                            {attributeOption?.clarityList?.map((x) => {
                              return (
                                <>
                                  <option value={x.Id}>{x.DiamondValue}</option>
                                  ;
                                </>
                              );
                            })}
                          </select>
                          </>
                           )}
                           {visibleLooseDiamondField && (
                            <>
                          <label>
                            Color <sup>*</sup>
                          </label>
                          <select
                            name="Color"
                            value={newCategory.Color}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            ref={inputRef5}
                            onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          >
                            <option value={''}>Select an option</option>;
                            {attributeOption?.colorList?.map((x) => {
                              return (
                                <>
                                  <option value={x.Id}>{x.DiamondValue}</option>
                                  ;
                                </>
                              );
                            })}
                          </select>
                          </>
                           )}





                          <label>
                            Short Name<sup>*</sup>
                          </label>
                          <input
                            name="ShortName"
                            value={newCategory.ShortName}
                            onChange={handleNewCategoryChange}
                            type="text"
                            maxLength={5}
                            minLength={0}
                            required="required"
                            className={style['addCategory-input']}
                            ref={inputRef6}
                            onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                          />
                          <label>Description</label>
                          <input
                            name="Description"
                            value={newCategory.Description}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style['addCategory-input']}
                            ref={inputRef7}
                            onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                          />
                          <label>Slug</label>
                          <input
                            name="Slug"
                            value={newCategory.Slug}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style['addCategory-input']}
                            ref={inputRef8}
                            onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                          />
                          
                        </div>
                      </Box>
                    </div>
                    <div className={style['btn-container']}>
                      <button type="submit">
                        <Icon width="24px" icon="ic:sharp-check" /> Submit
                      </button>
                      <button
                        style={{
                          backgroundColor: '#fff',
                          border: '1px solid #0077D4',
                          color: '#0077D4',
                        }}
                        onClick={handleReset}
                        id="reset-button"
                      >
                        <Icon width="24px" icon="ix:reset" /> Reset
                      </button>
                      <button onClick={handleCLick}>
                        <Icon width="24px" icon="fluent:list-rtl-16-filled" />{' '}
                        List
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
